<form
  class="update-record-dialog"
  [formGroup]="signedOffService.signOffForm"
  (ngSubmit)="onSignOffIssueFormSubmit()"
>
  <section class="record-summary" aria-label="Issue context">
    <div class="record-summary__icon" aria-hidden="true">
      <i class="pi pi-check-circle"></i>
    </div>

    <div class="record-summary__copy">
      <span class="record-summary__eyebrow">Sign Off Issue</span>

      <ng-container *ngIf="editFormGroups.length > 0; else singleIssue">
        <h2>
          {{ issueData.length }} issue{{ issueData.length !== 1 ? "s" : "" }}
          selected
        </h2>
        <div class="record-summary__meta">
          <span *ngFor="let d of issueData"
            >{{ d.vehicle_reference }}: {{ d.description }}</span
          >
        </div>
      </ng-container>

      <ng-template #singleIssue>
        <h2>{{ issueData.vehicle_reference }}</h2>
        <div class="record-summary__meta">
          <span>{{ issueData.description }}</span>
        </div>
      </ng-template>
    </div>
  </section>

  <section class="form-section">
    <div class="form-section__header">
      <h3>Sign-off details</h3>
    </div>

    <div class="form-grid">
      <div class="form-field form-field--wide">
        <label for="signoffType">Sign-off type</label>
        <p-dropdown
          inputId="signoffType"
          placeholder="Select a Sign Off Type"
          formControlName="signoff_type"
          optionLabel="signoff_type"
          [options]="signOfTypes"
          optionValue="signoff_type"
          [(ngModel)]="selectedSignOffType"
          (onChange)="toggleDropdown($event)"
          appendTo="body"
          styleClass="w-full"
        ></p-dropdown>
        <small
          class="p-error"
          *ngIf="
            signedOffService.signOffForm.get('signoff_type')?.invalid &&
            (signedOffService.signOffForm.get('signoff_type')?.touched ||
              signedOffService.signOffForm.get('signoff_type')?.dirty)
          "
        >
          <strong>Sign Off Type</strong> is required
        </small>
      </div>

      <div class="form-field form-field--wide" *ngIf="!signingOff">
        <label for="dateSigned">Date</label>
        <p-calendar
          inputId="dateSigned"
          formControlName="date_signed_off"
          dateFormat="yy-mm-dd"
          dataType="string"
          [inline]="false"
          [touchUI]="true"
          appendTo="body"
          styleClass="w-full"
        ></p-calendar>
        <small
          class="p-error"
          *ngIf="
            signedOffService.signOffForm.get('date_signed_off')?.invalid &&
            (signedOffService.signOffForm.get('date_signed_off')?.touched ||
              signedOffService.signOffForm.get('date_signed_off')?.dirty)
          "
        >
          <strong>Date</strong> is required
        </small>
      </div>
    </div>
  </section>

  <section class="form-section" *ngIf="selectedSignOffType === 'Fines'">
    <div class="form-section__header">
      <h3>Fine details</h3>
    </div>

    <div class="form-field">
      <label for="fineAmount">Fine Amount</label>
      <input
        id="fineAmount"
        [(ngModel)]="fine_amount"
        pInputText
        formControlName="fine_amount"
        class="w-full"
      />
      <small
        class="p-error"
        *ngIf="
          signedOffService.signOffForm.get('fine_amount')?.invalid &&
          (signedOffService.signOffForm.get('fine_amount')?.touched ||
            signedOffService.signOffForm.get('fine_amount')?.dirty)
        "
      >
        <strong>Fine Amount</strong> is required
      </small>
    </div>
  </section>

  <section class="form-section" *ngIf="selectedSignOffType === 'Technical'">
    <div class="form-section__header">
      <h3>Technical record</h3>
    </div>

    <div [formGroup]="technicalForm">
      <div class="form-grid">
        <div class="form-field">
          <label for="techDate">Date Completed</label>
          <p-calendar
            inputId="techDate"
            dateFormat="yy-mm-dd"
            dataType="string"
            [inline]="false"
            [touchUI]="true"
            appendTo="body"
            styleClass="w-full"
            [formControl]="technicalForm.controls['date_completed']"
          ></p-calendar>
        </div>

        <div class="form-field">
          <label for="techOdometer">Odometer</label>
          <input
            id="techOdometer"
            [formControl]="technicalForm.controls['odometer']"
            pInputText
            type="number"
            class="w-full"
          />
        </div>

        <div class="form-field form-field--wide">
          <label for="techRecordType">Record Type</label>
          <p-dropdown
            inputId="techRecordType"
            [formControl]="technicalForm.controls['record_type']"
            placeholder="Select Record Type"
            appendTo="body"
            [options]="record_types"
            optionLabel="name"
            optionValue="value"
            [(ngModel)]="selectedRecordType"
            (onChange)="onChange($event)"
            styleClass="w-full"
          ></p-dropdown>
        </div>
      </div>

      <div
        class="form-grid"
        style="margin-top: 1rem"
        *ngIf="selectedRecordType === 'service'"
      >
        <div class="form-field">
          <label for="serviceType">Service Type</label>
          <input
            id="serviceType"
            [formControl]="technicalForm.controls['service_type']"
            pInputText
            type="text"
            class="w-full"
          />
        </div>
        <div class="form-field">
          <label for="serviceJobNo">Service Job Number</label>
          <input
            id="serviceJobNo"
            [formControl]="technicalForm.controls['service_jobno']"
            pInputText
            type="text"
            class="w-full"
          />
        </div>
        <div class="form-field">
          <label for="serviceBrakes">Brakes %</label>
          <input
            id="serviceBrakes"
            [formControl]="technicalForm.controls['service_brakes']"
            pInputText
            type="number"
            class="w-full"
          />
        </div>
      </div>

      <div
        class="form-grid"
        style="margin-top: 1rem"
        *ngIf="selectedRecordType === 'tyres'"
      >
        <div class="form-field">
          <label for="tyreSize">Tyre Size</label>
          <input
            id="tyreSize"
            [formControl]="technicalForm.controls['tyre_size']"
            pInputText
            type="text"
            class="w-full"
          />
        </div>
        <div class="form-field">
          <label for="tyreType">Tyre Type</label>
          <input
            id="tyreType"
            [formControl]="technicalForm.controls['tyre_type']"
            pInputText
            type="text"
            class="w-full"
          />
        </div>
        <div class="form-field">
          <label for="tyrePos">Tyre Position</label>
          <input
            id="tyrePos"
            [formControl]="technicalForm.controls['tyre_pos']"
            pInputText
            type="text"
            class="w-full"
          />
        </div>
      </div>

      <div class="signoff-jobs-panel">
        <div class="form-section__header">
          <div>
            <h3>Jobs to sign off</h3>
            <span>Each job can have its own remarks</span>
          </div>
        </div>

        <div
          class="jobs-list"
          *ngIf="editFormGroups.length > 0; else singleJobRemarks"
        >
          <article
            class="job-card signoff-job-card"
            *ngFor="let jobForm of editFormGroups; let i = index"
            [formGroup]="jobForm"
          >
            <div class="job-card__header">
              <div class="signoff-job-card__title">
                <span>Job {{ i + 1 }}</span>
                <small>{{ jobForm.get("vehicle_reference")?.value }}</small>
              </div>
            </div>

            <div class="signoff-job-card__body">
              <p class="signoff-job-card__description">
                {{ displayJobDescription(jobForm.get("description")?.value) }}
              </p>

              <div class="form-field">
                <label for="remarkKeyword-{{ i }}">Action</label>
                <p-dropdown
                  id="remarkKeyword-{{ i }}"
                  formControlName="remark_keyword"
                  [options]="remarkKeywords"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Select action"
                  appendTo="body"
                  styleClass="w-full"
                ></p-dropdown>
              </div>

              <div class="form-field">
                <label for="jobRemarks-{{ i }}">More information</label>
                <textarea
                  id="jobRemarks-{{ i }}"
                  pInputTextarea
                  rows="3"
                  formControlName="remarks"
                  placeholder="Optional extra details"
                  class="w-full"
                ></textarea>
              </div>
            </div>
          </article>
        </div>

        <ng-template #singleJobRemarks>
          <article
            class="job-card signoff-job-card"
            [formGroup]="singleJobForm"
          >
            <div class="job-card__header">
              <div class="signoff-job-card__title">
                <span>Job 1</span>
                <small>
                  {{ singleJobForm.get("vehicle_reference")?.value }}
                </small>
              </div>
            </div>

            <div class="signoff-job-card__body">
              <p class="signoff-job-card__description">
                {{
                  displayJobDescription(singleJobForm.get("description")?.value)
                }}
              </p>

              <div class="form-field">
                <label for="singleRemarkKeyword">Action</label>
                <p-dropdown
                  id="singleRemarkKeyword"
                  formControlName="remark_keyword"
                  [options]="remarkKeywords"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Select action"
                  appendTo="body"
                  styleClass="w-full"
                ></p-dropdown>
              </div>

              <div class="form-field">
                <label for="singleJobRemarks">More information</label>
                <textarea
                  id="singleJobRemarks"
                  pInputTextarea
                  rows="3"
                  formControlName="remarks"
                  placeholder="Optional extra details"
                  class="w-full"
                ></textarea>
              </div>
            </div>
          </article>
        </ng-template>
      </div>
    </div>
  </section>

  <div class="dialog-actions">
    <button
      pButton
      type="submit"
      icon="pi pi-check"
      label="Sign Off Issue"
      class="p-button-primary w-full"
      [loading]="loading"
    ></button>
  </div>
</form>
